import { Component, Prop, Vue, Ref, Watch, Provide } from "vue-property-decorator";
import TileButton from "../tile-button/TileButton.vue";
import TileIcon from "../tile-icon/TileIcon.vue";
import HelperInfoButton from "../helper-info-button/HelperInfoButton.vue";

@Component({
    name: "Tile",
    components: {
        // TileButton needed for collapsed buttons rapresentation
        "tile-button": TileButton,
        "tile-icon": TileIcon,
        "helper-info-button": HelperInfoButton
    }
})
export default class Tile extends Vue {
    @Prop() readonly title!: string;
    @Prop({ type: Boolean }) readonly noButtons!: boolean;
    @Prop({ type: Boolean }) readonly hasBorderRadius!: boolean;
    @Prop({ type: Boolean }) readonly noOverflow!: boolean;
    @Prop({ type: Boolean }) readonly externalOverflow!: boolean;
    @Prop({ type: Boolean }) readonly noBackground!: boolean;
    @Prop({ type: Boolean }) readonly noPadding!: boolean;
    @Prop({ type: Boolean }) readonly noTopbar!: boolean;
    @Prop() readonly layoutUpdated!: number;
    @Prop({type: Boolean}) noContainerStyled!: boolean;
    @Prop({ type: String }) helperButtonPlacement!: string;
    @Prop({ type: String }) helperButtonTriggers!: string;

    @Ref("content") content!: HTMLElement;
    @Ref("tile") tile!: HTMLDivElement;
    @Ref("actionButtons") actionButtons!: HTMLElement;
    @Ref("contentButtons") contentButtons!: HTMLElement;

    @Provide("isMenuEnabled")
    isMenuEnabled() {
        return this.enableMenu;
    }

    enableMenu = false;
    alreadyUpdated = false;
    numOfContentButtons = 0;
    numOfTileButtons = 0;

    private hasOppositeTileButtons = process.env.VUE_APP_OPPOSITE_TILE_BUTTONS != undefined ? process.env.VUE_APP_OPPOSITE_TILE_BUTTONS : false;

    beforeUpdate() {
        requestAnimationFrame(() =>
            this.checkForSlotContent());
    }

    mounted() {
        requestAnimationFrame(() =>
            this.checkForSlotContent());
    }

    @Watch('layoutUpdated')
    private onLayoutUpdated() {
        this.handleResize();
    }

    private get tag(){
        return this.$parent.$vnode.componentOptions?.tag?.toLowerCase();
    }

    private get showInfo(){
        const id = this.tag;
        return this.$t(`widget-subtitle-${id}`) != `widget-subtitle-${id}` || this.$t(`widget-descr-${id}`) != `widget-descr-${id}`;
    }

    private get isContentSideCardOpen() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.$slots['content-buttons']?.some(node => (node.componentOptions?.propsData as any)?.value)
    }

    private get isTileSideCardOpen() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.$slots['tile-buttons']?.some(node => (node.componentOptions?.propsData as any)?.value)
    }

    private checkForSlotContent() {

        const tempNumOfContentbutton = this.$slots['content-buttons']?.filter(node => node.tag).length || 0;
        const tempNumOfTileButtons = this.$slots['tile-buttons']?.filter(node => node.tag).length || 0;

        if (this.numOfContentButtons != tempNumOfContentbutton || this.numOfTileButtons != tempNumOfTileButtons) {
            this.numOfTileButtons = tempNumOfTileButtons || 0;
            this.numOfContentButtons = tempNumOfContentbutton || 0;
            this.handleResize();
        }
    }

    private get numOfTotalButtons() {
        return this.numOfContentButtons + this.numOfTileButtons;
    }

    updated() {
        if (this.alreadyUpdated) {
            return;
        }
        this.alreadyUpdated = true;
        const content = this.content.clientHeight;
        const fullActions = this.computeFullActions();
        if (fullActions > content) {
            this.enableMenu = true;
        }
    }

    handleResize() {
        if (this.noButtons) {
            return;
        }
        this.alreadyUpdated = false;
        const contentHeight = this.content.clientHeight;
        const fullActions = this.computeFullActions();
        if (contentHeight < fullActions) {
            this.enableMenu = true;
            return;
        }
        this.enableMenu = false;
    }

    computeFullActions() {
        if (this.noButtons || (!this.actionButtons && !this.contentButtons)) {
            return 0;
        }
        const tileButton = this.actionButtons.clientHeight;
        let contentButton = this.contentButtons.clientHeight;
        if (contentButton) {
            contentButton += parseFloat(window.getComputedStyle(this.contentButtons).marginTop);
        }
        return tileButton + contentButton;
    }

}
